import { useMutation, useQuery } from "react-query";
import { Count, ServerError, NameAndId, PageFilter } from "../../data";
import { useAxios } from "../../hooks";

export const useGetCoupons = (filter: CouponFilter) => {
  const axios = useAxios();

  const path = "/coupons/api";
  return useQuery<Count<CouponData>, ServerError>({
    queryKey: ["coupons", filter],
    keepPreviousData: true,
    initialData: { items: [], total: 0 },
    queryFn: () =>
      axios.get(path, {
        params: filter,
      }),
  });
};
export const useGetCouponType = () => {
  const axios = useAxios();

  const path = "/coupons/api/coupon-types";
  return useQuery<NameAndId[], ServerError>({
    queryKey: ["coupon-types"],
    initialData: [],
    queryFn: () => axios.get(path, {}),
  });
};

export const useGetCountries = () => {
  const axios = useAxios();

  const path = "/coupons/api/countries";
  return useQuery<NameAndId[], ServerError>({
    queryKey: ["coupon-countries"],
    initialData: [],
    queryFn: () => axios.get(path, {}),
  });
};
export const useGetMerchants = () => {
  const axios = useAxios();

  const path = "/merchants/api/merchants/names";
  return useQuery<MerchantNameData[], ServerError>({
    queryKey: ["coupon-merchants", {}],
    initialData: [],
    queryFn: () => axios.get(path, { params: {} }),
  });
};
export const useAddCoupon = () => {
  const axios = useAxios();

  const path = "/coupons/api";
  return useMutation<unknown, ServerError, CouponModel>((data) => {
    return axios.post(path, data);
  });
};

export const useEditCoupon = (id: any) => {
  const axios = useAxios();

  return useMutation<unknown, ServerError, CouponModel>((data) => {
    const path = `/coupons/api/${id}`;
    return axios.post(path, data);
  });
};
export const useDeleteCoupon = () => {
  const axios = useAxios();

  return useMutation<unknown, ServerError, number>((id?: number) => {
    const path = `/coupons/api/${id}`;
    return axios.delete(path);
  });
};

export const useChangeCouponStatus = () => {
  const axios = useAxios();

  return useMutation<unknown, ServerError, number>((id?: number) => {
    const path = `/coupons/api/${id}/status`;
    return axios.post(path);
  });
};
export interface MerchantNameData {
  id: number;
  name: string;
  isGeneric: boolean;
  isActive: boolean;
}
export interface CouponModel {
  code: string;
  type: any;
  value: number;
  minimumCap: number;
  maximumCap: number;
  totalUsage: number;
  usagePerUser: number;
  expiryDate: string;
  merchants: string[];
  users: string[];
  startDate: string;
}
export interface CouponData {
  code: string;
  id: number;
  typeId: string;
  type: string;
  dateCreated: string;
  expiryDate: string;
  isActive: boolean;
  maximumCap: number;
  minimumCap: number;
  value: number;
  totalUsage: number;
  startDate: string;
  usagePerUser: number;
  merchants: MerchantData[];
  users: string[];
}

export interface MerchantData {
  merchantId: string;
  merchantName: string;
}
export interface CouponFilter extends PageFilter {
  status?: boolean;
}
